export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/srv/build/frontend/src/pages/index.vue'),
    children: [
      {
        path: '',
        name: '//',
        component: () => import('/srv/build/frontend/src/pages/index/index.vue'),
        /* no children */
      },
      {
        path: 'class',
        /* internal name: '//class' */
        /* no component */
        children: [
          {
            path: ':classId',
            /* internal name: '//class/[classId]' */
            /* no component */
            children: [
              {
                path: 'reports',
                name: '//class/[classId]/reports',
                component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/reports.vue'),
                children: [
                  {
                    path: '',
                    name: '//class/[classId]/reports/',
                    component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/reports/index.vue'),
                    /* no children */
                  },
                  {
                    path: 'allReports',
                    name: '//class/[classId]/reports/allReports',
                    component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/reports/allReports.vue'),
                    /* no children */
                  },
                  {
                    path: 'group',
                    /* internal name: '//class/[classId]/reports/group' */
                    /* no component */
                    children: [
                      {
                        path: ':reportGroupId',
                        name: '//class/[classId]/reports/group/[reportGroupId]',
                        component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/reports/group/[reportGroupId].vue'),
                        /* no children */
                      }
                    ],
                  }
                ],
              },
              {
                path: 'settings',
                /* internal name: '//class/[classId]/settings' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//class/[classId]/settings/',
                    component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/settings/index.vue'),
                    /* no children */
                  },
                  {
                    path: 'classTeam',
                    /* internal name: '//class/[classId]/settings/classTeam' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//class/[classId]/settings/classTeam/',
                        component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/settings/classTeam/index.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'data',
                    /* internal name: '//class/[classId]/settings/data' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//class/[classId]/settings/data/',
                        component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/settings/data/index.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'performanceAssessments',
                    /* internal name: '//class/[classId]/settings/performanceAssessments' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//class/[classId]/settings/performanceAssessments/',
                        component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/settings/performanceAssessments/index.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'performanceVisual',
                    /* internal name: '//class/[classId]/settings/performanceVisual' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//class/[classId]/settings/performanceVisual/',
                        component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/settings/performanceVisual/index.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'schoolSubjects',
                    /* internal name: '//class/[classId]/settings/schoolSubjects' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//class/[classId]/settings/schoolSubjects/',
                        component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/settings/schoolSubjects/index.vue'),
                        /* no children */
                      },
                      {
                        path: ':schoolSubjectId',
                        /* internal name: '//class/[classId]/settings/schoolSubjects/[schoolSubjectId]' */
                        /* no component */
                        children: [
                          {
                            path: 'competences',
                            name: '//class/[classId]/settings/schoolSubjects/[schoolSubjectId]/competences',
                            component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/settings/schoolSubjects/[schoolSubjectId]/competences.vue'),
                            /* no children */
                          }
                        ],
                      }
                    ],
                  },
                  {
                    path: 'students',
                    /* internal name: '//class/[classId]/settings/students' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//class/[classId]/settings/students/',
                        component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/settings/students/index.vue'),
                        /* no children */
                      }
                    ],
                  }
                ],
              },
              {
                path: 'statistics',
                name: '//class/[classId]/statistics',
                component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/statistics.vue'),
                /* no children */
              },
              {
                path: 'student',
                name: '//class/[classId]/student',
                component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/student.vue'),
                children: [
                  {
                    path: '',
                    name: '//class/[classId]/student/',
                    component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/student/index.vue'),
                    /* no children */
                  },
                  {
                    path: ':studentId',
                    name: '//class/[classId]/student/[studentId]',
                    component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/student/[studentId].vue'),
                    /* no children */
                  },
                  {
                    path: 'observation-timeline',
                    name: '//class/[classId]/student/observation-timeline',
                    component: () => import('/srv/build/frontend/src/pages/index/class/[classId]/student/observation-timeline.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'profile',
        name: '//profile',
        component: () => import('/srv/build/frontend/src/pages/index/profile.vue'),
        /* no children */
      },
      {
        path: 'provider',
        /* internal name: '//provider' */
        /* no component */
        children: [
          {
            path: '',
            name: '//provider/',
            component: () => import('/srv/build/frontend/src/pages/index/provider/index.vue'),
            /* no children */
          },
          {
            path: 'home',
            /* internal name: '//provider/home' */
            /* no component */
            children: [
              {
                path: '',
                name: '//provider/home/',
                component: () => import('/srv/build/frontend/src/pages/index/provider/home/index.vue'),
                /* no children */
              },
              {
                path: 'emails',
                name: '//provider/home/emails',
                component: () => import('/srv/build/frontend/src/pages/index/provider/home/emails.vue'),
                /* no children */
              },
              {
                path: 'externalMaterials',
                name: '//provider/home/externalMaterials',
                component: () => import('/srv/build/frontend/src/pages/index/provider/home/externalMaterials.vue'),
                /* no children */
              },
              {
                path: 'schoolSubjectTypes',
                name: '//provider/home/schoolSubjectTypes',
                component: () => import('/srv/build/frontend/src/pages/index/provider/home/schoolSubjectTypes.vue'),
                /* no children */
              },
              {
                path: 'statistics',
                name: '//provider/home/statistics',
                component: () => import('/srv/build/frontend/src/pages/index/provider/home/statistics.vue'),
                /* no children */
              },
              {
                path: 'subjects',
                name: '//provider/home/subjects',
                component: () => import('/srv/build/frontend/src/pages/index/provider/home/subjects.vue'),
                /* no children */
              },
              {
                path: 'tenant',
                name: '//provider/home/tenant',
                component: () => import('/srv/build/frontend/src/pages/index/provider/home/tenant.vue'),
                /* no children */
              },
              {
                path: 'user',
                name: '//provider/home/user',
                component: () => import('/srv/build/frontend/src/pages/index/provider/home/user.vue'),
                /* no children */
              },
              {
                path: 'userFeedback',
                name: '//provider/home/userFeedback',
                component: () => import('/srv/build/frontend/src/pages/index/provider/home/userFeedback.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'masterData',
            /* internal name: '//provider/masterData' */
            /* no component */
            children: [
              {
                path: '',
                name: '//provider/masterData/',
                component: () => import('/srv/build/frontend/src/pages/index/provider/masterData/index.vue'),
                /* no children */
              },
              {
                path: 'countries',
                name: '//provider/masterData/countries',
                component: () => import('/srv/build/frontend/src/pages/index/provider/masterData/countries.vue'),
                /* no children */
              },
              {
                path: 'language',
                name: '//provider/masterData/language',
                component: () => import('/srv/build/frontend/src/pages/index/provider/masterData/language.vue'),
                /* no children */
              },
              {
                path: 'school',
                name: '//provider/masterData/school',
                component: () => import('/srv/build/frontend/src/pages/index/provider/masterData/school.vue'),
                /* no children */
              },
              {
                path: 'schoolTypeConfigurations',
                name: '//provider/masterData/schoolTypeConfigurations',
                component: () => import('/srv/build/frontend/src/pages/index/provider/masterData/schoolTypeConfigurations.vue'),
                /* no children */
              },
              {
                path: 'schoolTypes',
                name: '//provider/masterData/schoolTypes',
                component: () => import('/srv/build/frontend/src/pages/index/provider/masterData/schoolTypes.vue'),
                /* no children */
              },
              {
                path: 'schoolYear',
                name: '//provider/masterData/schoolYear',
                component: () => import('/srv/build/frontend/src/pages/index/provider/masterData/schoolYear.vue'),
                /* no children */
              },
              {
                path: 'states',
                name: '//provider/masterData/states',
                component: () => import('/srv/build/frontend/src/pages/index/provider/masterData/states.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'monitoring',
            /* internal name: '//provider/monitoring' */
            /* no component */
            children: [
              {
                path: '',
                name: '//provider/monitoring/',
                component: () => import('/srv/build/frontend/src/pages/index/provider/monitoring/index.vue'),
                /* no children */
              },
              {
                path: 'cron',
                name: '//provider/monitoring/cron',
                component: () => import('/srv/build/frontend/src/pages/index/provider/monitoring/cron.vue'),
                /* no children */
              },
              {
                path: 'onboardingCheckout',
                name: '//provider/monitoring/onboardingCheckout',
                component: () => import('/srv/build/frontend/src/pages/index/provider/monitoring/onboardingCheckout.vue'),
                /* no children */
              },
              {
                path: 'queue',
                name: '//provider/monitoring/queue',
                component: () => import('/srv/build/frontend/src/pages/index/provider/monitoring/queue.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'system',
            /* internal name: '//provider/system' */
            /* no component */
            children: [
              {
                path: '',
                name: '//provider/system/',
                component: () => import('/srv/build/frontend/src/pages/index/provider/system/index.vue'),
                /* no children */
              },
              {
                path: 'apiToken',
                name: '//provider/system/apiToken',
                component: () => import('/srv/build/frontend/src/pages/index/provider/system/apiToken.vue'),
                /* no children */
              },
              {
                path: 'release',
                name: '//provider/system/release',
                component: () => import('/srv/build/frontend/src/pages/index/provider/system/release.vue'),
                /* no children */
              },
              {
                path: 'sso',
                name: '//provider/system/sso',
                component: () => import('/srv/build/frontend/src/pages/index/provider/system/sso.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'templates',
            /* internal name: '//provider/templates' */
            /* no component */
            children: [
              {
                path: '',
                name: '//provider/templates/',
                component: () => import('/srv/build/frontend/src/pages/index/provider/templates/index.vue'),
                /* no children */
              },
              {
                path: 'competenceAssessments',
                name: '//provider/templates/competenceAssessments',
                component: () => import('/srv/build/frontend/src/pages/index/provider/templates/competenceAssessments.vue'),
                /* no children */
              },
              {
                path: 'gradeScales',
                name: '//provider/templates/gradeScales',
                component: () => import('/srv/build/frontend/src/pages/index/provider/templates/gradeScales.vue'),
                /* no children */
              },
              {
                path: 'performanceAssessments',
                name: '//provider/templates/performanceAssessments',
                component: () => import('/srv/build/frontend/src/pages/index/provider/templates/performanceAssessments.vue'),
                /* no children */
              },
              {
                path: 'performanceVisuals',
                name: '//provider/templates/performanceVisuals',
                component: () => import('/srv/build/frontend/src/pages/index/provider/templates/performanceVisuals.vue'),
                /* no children */
              },
              {
                path: 'templateSetImport',
                name: '//provider/templates/templateSetImport',
                component: () => import('/srv/build/frontend/src/pages/index/provider/templates/templateSetImport.vue'),
                /* no children */
              },
              {
                path: 'templateSets',
                /* internal name: '//provider/templates/templateSets' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//provider/templates/templateSets/',
                    component: () => import('/srv/build/frontend/src/pages/index/provider/templates/templateSets/index.vue'),
                    /* no children */
                  },
                  {
                    path: ':templateSetId',
                    /* internal name: '//provider/templates/templateSets/[templateSetId]' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//provider/templates/templateSets/[templateSetId]/',
                        component: () => import('/srv/build/frontend/src/pages/index/provider/templates/templateSets/[templateSetId]/index.vue'),
                        /* no children */
                      },
                      {
                        path: ':schoolSubjectId',
                        /* internal name: '//provider/templates/templateSets/[templateSetId]/[schoolSubjectId]' */
                        /* no component */
                        children: [
                          {
                            path: 'competences',
                            name: '//provider/templates/templateSets/[templateSetId]/[schoolSubjectId]/competences',
                            component: () => import('/srv/build/frontend/src/pages/index/provider/templates/templateSets/[templateSetId]/[schoolSubjectId]/competences.vue'),
                            /* no children */
                          }
                        ],
                      }
                    ],
                  }
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'school',
        /* internal name: '//school' */
        /* no component */
        children: [
          {
            path: ':schoolId',
            /* internal name: '//school/[schoolId]' */
            /* no component */
            children: [
              {
                path: 'settings',
                /* internal name: '//school/[schoolId]/settings' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '//school/[schoolId]/settings/',
                    component: () => import('/srv/build/frontend/src/pages/index/school/[schoolId]/settings/index.vue'),
                    /* no children */
                  },
                  {
                    path: 'billing',
                    /* internal name: '//school/[schoolId]/settings/billing' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//school/[schoolId]/settings/billing/',
                        component: () => import('/srv/build/frontend/src/pages/index/school/[schoolId]/settings/billing/index.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'classes',
                    /* internal name: '//school/[schoolId]/settings/classes' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//school/[schoolId]/settings/classes/',
                        component: () => import('/srv/build/frontend/src/pages/index/school/[schoolId]/settings/classes/index.vue'),
                        /* no children */
                      },
                      {
                        path: ':classId',
                        /* internal name: '//school/[schoolId]/settings/classes/[classId]' */
                        /* no component */
                        children: [
                          {
                            path: 'students',
                            /* internal name: '//school/[schoolId]/settings/classes/[classId]/students' */
                            /* no component */
                            children: [
                              {
                                path: '',
                                name: '//school/[schoolId]/settings/classes/[classId]/students/',
                                component: () => import('/srv/build/frontend/src/pages/index/school/[schoolId]/settings/classes/[classId]/students/index.vue'),
                                /* no children */
                              }
                            ],
                          }
                        ],
                      }
                    ],
                  },
                  {
                    path: 'data',
                    /* internal name: '//school/[schoolId]/settings/data' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//school/[schoolId]/settings/data/',
                        component: () => import('/srv/build/frontend/src/pages/index/school/[schoolId]/settings/data/index.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'gradeCalculation',
                    /* internal name: '//school/[schoolId]/settings/gradeCalculation' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//school/[schoolId]/settings/gradeCalculation/',
                        component: () => import('/srv/build/frontend/src/pages/index/school/[schoolId]/settings/gradeCalculation/index.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'groups',
                    /* internal name: '//school/[schoolId]/settings/groups' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//school/[schoolId]/settings/groups/',
                        component: () => import('/srv/build/frontend/src/pages/index/school/[schoolId]/settings/groups/index.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'performanceAssessments',
                    /* internal name: '//school/[schoolId]/settings/performanceAssessments' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//school/[schoolId]/settings/performanceAssessments/',
                        component: () => import('/srv/build/frontend/src/pages/index/school/[schoolId]/settings/performanceAssessments/index.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'performanceVisual',
                    /* internal name: '//school/[schoolId]/settings/performanceVisual' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//school/[schoolId]/settings/performanceVisual/',
                        component: () => import('/srv/build/frontend/src/pages/index/school/[schoolId]/settings/performanceVisual/index.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'schoolSubjectTemplates',
                    /* internal name: '//school/[schoolId]/settings/schoolSubjectTemplates' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//school/[schoolId]/settings/schoolSubjectTemplates/',
                        component: () => import('/srv/build/frontend/src/pages/index/school/[schoolId]/settings/schoolSubjectTemplates/index.vue'),
                        /* no children */
                      },
                      {
                        path: ':schoolSubjectId',
                        /* internal name: '//school/[schoolId]/settings/schoolSubjectTemplates/[schoolSubjectId]' */
                        /* no component */
                        children: [
                          {
                            path: 'competences',
                            name: '//school/[schoolId]/settings/schoolSubjectTemplates/[schoolSubjectId]/competences',
                            component: () => import('/srv/build/frontend/src/pages/index/school/[schoolId]/settings/schoolSubjectTemplates/[schoolSubjectId]/competences.vue'),
                            /* no children */
                          }
                        ],
                      }
                    ],
                  },
                  {
                    path: 'schoolYears',
                    /* internal name: '//school/[schoolId]/settings/schoolYears' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//school/[schoolId]/settings/schoolYears/',
                        component: () => import('/srv/build/frontend/src/pages/index/school/[schoolId]/settings/schoolYears/index.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'securityAndPrivacy',
                    /* internal name: '//school/[schoolId]/settings/securityAndPrivacy' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//school/[schoolId]/settings/securityAndPrivacy/',
                        component: () => import('/srv/build/frontend/src/pages/index/school/[schoolId]/settings/securityAndPrivacy/index.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'students',
                    /* internal name: '//school/[schoolId]/settings/students' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//school/[schoolId]/settings/students/',
                        component: () => import('/srv/build/frontend/src/pages/index/school/[schoolId]/settings/students/index.vue'),
                        /* no children */
                      }
                    ],
                  },
                  {
                    path: 'user',
                    /* internal name: '//school/[schoolId]/settings/user' */
                    /* no component */
                    children: [
                      {
                        path: '',
                        name: '//school/[schoolId]/settings/user/',
                        component: () => import('/srv/build/frontend/src/pages/index/school/[schoolId]/settings/user/index.vue'),
                        /* no children */
                      }
                    ],
                  }
                ],
              }
            ],
          }
        ],
      },
      {
        path: 'waiting-room',
        name: '//waiting-room',
        component: () => import('/srv/build/frontend/src/pages/index/waiting-room.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: () => import('/srv/build/frontend/src/pages/[...path].vue'),
    /* no children */
  },
  {
    path: '/auth',
    name: '/auth',
    component: () => import('/srv/build/frontend/src/pages/auth.vue'),
    children: [
      {
        path: 'email-change',
        name: '/auth/email-change',
        component: () => import('/srv/build/frontend/src/pages/auth/email-change.vue'),
        /* no children */
      },
      {
        path: 'finish-registration',
        name: '/auth/finish-registration',
        component: () => import('/srv/build/frontend/src/pages/auth/finish-registration.vue'),
        /* no children */
      },
      {
        path: 'login',
        name: '/auth/login',
        component: () => import('/srv/build/frontend/src/pages/auth/login.vue'),
        /* no children */
      },
      {
        path: 'password-reset',
        name: '/auth/password-reset',
        component: () => import('/srv/build/frontend/src/pages/auth/password-reset.vue'),
        /* no children */
      },
      {
        path: 'register',
        name: '/auth/register',
        component: () => import('/srv/build/frontend/src/pages/auth/register.vue'),
        /* no children */
      },
      {
        path: 'reset-password',
        name: '/auth/reset-password',
        component: () => import('/srv/build/frontend/src/pages/auth/reset-password.vue'),
        /* no children */
      },
      {
        path: 'sso',
        /* internal name: '/auth/sso' */
        /* no component */
        children: [
          {
            path: 'error',
            name: '/auth/sso/error',
            component: () => import('/srv/build/frontend/src/pages/auth/sso/error.vue'),
            /* no children */
          },
          {
            path: 'start',
            /* internal name: '/auth/sso/start' */
            /* no component */
            children: [
              {
                path: ':providerId',
                name: '/auth/sso/start/[providerId]',
                component: () => import('/srv/build/frontend/src/pages/auth/sso/start/[providerId].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'success',
            name: '/auth/sso/success',
            component: () => import('/srv/build/frontend/src/pages/auth/sso/success.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/onboarding',
    name: '/onboarding',
    component: () => import('/srv/build/frontend/src/pages/onboarding.vue'),
    children: [
      {
        path: '',
        name: '/onboarding/',
        component: () => import('/srv/build/frontend/src/pages/onboarding/index.vue'),
        /* no children */
      },
      {
        path: 'school',
        name: '/onboarding/school',
        component: () => import('/srv/build/frontend/src/pages/onboarding/school.vue'),
        /* no children */
      },
      {
        path: 'user',
        name: '/onboarding/user',
        component: () => import('/srv/build/frontend/src/pages/onboarding/user.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/pae-pdf-print',
    name: '/pae-pdf-print',
    component: () => import('/srv/build/frontend/src/pages/pae-pdf-print.vue'),
    /* no children */
  },
  {
    path: '/pdf-print',
    name: '/pdf-print',
    component: () => import('/srv/build/frontend/src/pages/pdf-print.vue'),
    /* no children */
  },
  {
    path: '/referral',
    name: '/referral',
    component: () => import('/srv/build/frontend/src/pages/referral.vue'),
    /* no children */
  },
  {
    path: '/template-set-pdf-print',
    name: '/template-set-pdf-print',
    component: () => import('/srv/build/frontend/src/pages/template-set-pdf-print.vue'),
    /* no children */
  },
  {
    path: '/user',
    /* internal name: '/user' */
    /* no component */
    children: [
      {
        path: 'invitations',
        name: '/user/invitations',
        component: () => import('/srv/build/frontend/src/pages/user/invitations.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

